import { render, staticRenderFns } from "./marketing-waitlist-cta.vue?vue&type=template&id=481b1318&scoped=true&"
import script from "./marketing-waitlist-cta.vue?vue&type=script&lang=js&"
export * from "./marketing-waitlist-cta.vue?vue&type=script&lang=js&"
import style0 from "./marketing-waitlist-cta.vue?vue&type=style&index=0&id=481b1318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481b1318",
  null
  
)

export default component.exports